<template>
    <label :id="`listbox-item-${name}`" :for="name" :class="{'mb-1': hasMargin, 'text-red-500 dark:text-red-500': hasError}"
           class="block text-sm font-medium text-gray-700 dark:text-gray-300">
        <slot/>
    </label>
</template>

<script>
export default {
    name: 'FormLabel',

    props: {
        name: {
            type: String,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        hasMargin: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
